import '../vendor/lightbox';

lightGallery(document.getElementById('sert'));
lightGallery(document.getElementById('sale'));
